<template>
  <div class="mt-6 text-nucleus-text">
    {{ heading }}
    <span
      class="inline text-nucleus-primaryBlue hover:text-nucleus-primaryMouseOver underline transition ml-1 cursor-pointer"
      >{{ linkText }}</span
    >
  </div>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component";

@Options({
  props: {
    heading: String,
    to: String,
    linkText: String,
  },
})
export default class HintLink extends Vue {}
</script>
